import React from 'react'
import _ from 'lodash'

import barcodes from 'server/utils/barcodes.js'

import {Colors, IconButton, P, Row, S1} from '../UI/index.js'
import {FormRow, FormStack, Input, MetricInput, Select, formSpacing} from '../UI/forms/index.js'

class EditCollo extends React.PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            collo: null
        }
    }

    componentDidMount() {
        if (this.props.onSave) {
            this.setState({collo: structuredClone(this.props.collo)})
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.collo !== this.props.collo) {
            if (this.props.onSave) {
                this.setState({collo: structuredClone(this.props.collo)})
            }
        }
    }

    onChangeValue(path, parser, event) {
        if (!event) {
            event = parser
            parser = undefined
        }

        let collo = {...this.props.collo}

        if (this.props.onSave) {
            collo = {...this.state.collo}
        }

        if (typeof parser === 'function') {
            _.set(collo, path, parser(event.target.value))
        } else {
            _.set(collo, path, event.target.value)
        }

        if (this.props.onSave) {
            this.setState({collo})
        } else {
            this.props.onChange(collo)
        }
    }

    onChangeBarcode(barcode) {
        if (this.props.onSave) {
            this.setState({collo: {...this.state.collo, barcode}})
        } else {
            this.props.onChange({...this.props.collo, barcode})
        }
    }

    render() {
        let {order, collo, onRemove, onSave, reseller, customer} = this.props

        if (this.props.onSave) {
            collo = {...this.state.collo}
        }

        const hasBarcode = !!collo.barcode && collo.barcode !== 'no barcode'

        const pickupAddresses = _.filter(order.addresses, (address, index) => {
            address.index = index
            return address.type === 'pickup'
        })

        const deliveryAddresses = _.filter(order.addresses, (address) => address.type === 'delivery')

        const resellerColliTypes = reseller.settings.orders.colliTypes || []
        const customerAllowedColliTypes = customer?.settings.orders?.allowedColliTypes
        const defaultColliTypes = reseller.settings.orders.defaultColliTypes

        const colliTypes = Array.isArray(customerAllowedColliTypes) ?
            resellerColliTypes.filter((type) => customerAllowedColliTypes.includes(type.id)) :
            resellerColliTypes.filter((type) => !Array.isArray(defaultColliTypes) || defaultColliTypes.includes(type.id))

        return (
            <div style={{width: '100%', background: Colors.grey20, borderRadius: 4, padding: formSpacing.inset}}>
                <Row style={{alignItems: 'center', marginBottom: 12}}>
                    <S1 style={{width: 20, marginRight: 12}}>{(collo.index || 0) + 1}</S1>

                    <P>{hasBarcode ? collo.barcode : 'Geen barcode'}</P>

                    {hasBarcode ?
                        <IconButton
                            tooltip='Barcode wissen'
                            onClick={this.onChangeBarcode.bind(this, 'no barcode')}
                        >
                            <i className='mdi mdi-close' />
                        </IconButton> :
                        <IconButton
                            tooltip='Nieuwe barcode genereren'
                            onClick={() => this.onChangeBarcode(barcodes.generate())}
                        >
                            <i className='mdi mdi-refresh' />
                        </IconButton>
                    }

                    <div style={{flex: 1}} />

                    {!!onRemove &&
                        <IconButton onClick={onRemove}>
                            <i className='mdi mdi-delete' />
                        </IconButton>
                    }

                    {!!onSave &&
                        <IconButton onClick={() => onSave(this.state.collo)}>
                            <i className='mdi mdi-check' />
                        </IconButton>
                    }
                </Row>

                <FormStack>
                    <FormRow>
                        <Select
                            label='Type'
                            allowEmpty
                            value={collo.type}
                            options={colliTypes.map((option) => {
                                return {value: option.id, title: option.name}
                            })}
                            onChange={this.onChangeValue.bind(this, 'type')}
                        />

                        <Input
                            label='Omschrijving'
                            value={collo.description}
                            onChange={this.onChangeValue.bind(this, 'description')}
                        />
                    </FormRow>

                    <FormRow>
                        <MetricInput
                            label='Gewicht'
                            max={999999999}
                            divisionFactor={1000}
                            value={collo.weight}
                            onChange={this.onChangeValue.bind(this, 'weight')}
                            append='kg'
                        />

                        <MetricInput
                            label='Lengte'
                            max={999999999}
                            divisionFactor={10}
                            value={collo.length}
                            onChange={this.onChangeValue.bind(this, 'length')}
                            append='cm'
                        />

                        <MetricInput
                            label='Breedte'
                            max={999999999}
                            divisionFactor={10}
                            value={collo.width}
                            onChange={this.onChangeValue.bind(this, 'width')}
                            append='cm'
                        />

                        <MetricInput
                            label='Hoogte'
                            max={999999999}
                            divisionFactor={10}
                            value={collo.height}
                            onChange={this.onChangeValue.bind(this, 'height')}
                            append='cm'
                        />
                    </FormRow>

                    {(order.addresses.length > 2 || (order.addresses.length === 2 && order.addresses[0].type === order.addresses[1].type)) &&
                        <FormRow>
                            {pickupAddresses.length > 0 &&
                                <Select
                                    label='Ophaaladres'
                                    value={pickupAddresses.length === 1 ? pickupAddresses[0].index : collo.pickupAddressIndex}
                                    readOnly={pickupAddresses.length === 1}
                                    options={pickupAddresses.map((address) => {
                                        return {value: address.index, title: `${(address.isBusiness && address.name) ? address.name : `${address.street} ${address.nr}${address.addition}`}`}
                                    })}
                                    onChange={this.onChangeValue.bind(this, 'pickupAddressIndex', parseInt)}
                                />
                            }

                            {deliveryAddresses.length > 0 &&
                                <Select
                                    label='Bezorgadres'
                                    value={deliveryAddresses.length === 1 ? deliveryAddresses[0].index : collo.deliveryAddressIndex}
                                    readOnly={deliveryAddresses.length === 1}
                                    options={deliveryAddresses.map((address) => {
                                        return {value: address.index, title: `${(address.isBusiness && address.name) ? address.name : `${address.street} ${address.nr}${address.addition}`}`}
                                    })}
                                    onChange={this.onChangeValue.bind(this, 'deliveryAddressIndex', parseInt)}
                                />
                            }
                        </FormRow>
                    }
                </FormStack>
            </div>
        )
    }
}

export default EditCollo
